import Image from "next/image";

function Patent({ blok }) {
    return <div className='m-auto bg-asmPageTopBG bg-center bg-cover w-full flex flex-col items-center font-aileron'>
        <div className="max-w-7xl w-full flex flex-col items-center justify-center px-4 lg:px-0 py-20 lg:py-48">
            {/* Heading */}
            <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-20 justify-center">
                <div className="w-[120px] lg:w-[153px] h-[150px] lg:h-[190px] flex flex-col items-center justify-center mx-auto lg:mx-0">
                    <img src={blok.Image.filename} alt={blok.Image.alt} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 flex flex-col justify-center text-center lg:text-left">
                    <h2 className="bg-custom-radial bg-clip-text text-transparent text-[36px] lg:text-[80px] font-bold">
                        {blok.Heading.replace(/\u00A0/g, " ")}
                    </h2>
                    <p className="text-[16px] lg:text-[18px] font-normal mt-2">
                        {blok.Subheading.replace(/\u00A0/g, " ")}
                    </p>
                </div>
            </div>
            {/* Patent Sections */}
            <div className="flex flex-col w-full gap-8 lg:gap-[54px] justify-center mt-8 lg:mt-[48px]">
                {blok.PatentSections.map((section, index) => (
                    <div key={index} className="flex-1 flex flex-col justify-center">
                        {/** Patent Heading */}
                        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-4 text-center lg:text-left">
                            <Image src={section.Icon.filename} alt={section.Icon.alt} className="w-16 h-16 lg:w-20 lg:h-20 object-contain" width={20} height={20} />
                            <h3 className="bg-custom-radial bg-clip-text text-transparent text-[32px] lg:text-[48px] font-bold">
                                {section.Heading.replace(/\u00A0/g, " ")}
                            </h3>
                        </div>
                        <p className="text-[16px] lg:text-[18px] font-normal mt-4 text-center lg:text-left">
                            {section.Description.replace(/\u00A0/g, " ")}
                        </p>
                        <div className="flex flex-col gap-6 lg:gap-8 mt-6 lg:mt-8">
                            {section?.Cards?.map((content, index) => (
                                <div key={index} className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-br from-[#D259A6]/80 to-[#48398C]/50">
                                    <div className="h-full w-full bg-gradient-to-b from-[#FBFBFC] to-[#FCFCFD] rounded-lg flex flex-col justify-start items-start text-left py-[2px] px-[2px]">
                                        <div className="bg-[#5A27E7] rounded-t-[10px] rounded-b-none w-full min-h-[40px] lg:h-10 flex flex-col lg:flex-row items-start lg:items-center px-4 lg:px-6 py-4 lg:py-8">
                                            <div className="flex-1 flex flex-col lg:flex-row gap-2 text-[16px] lg:text-[20px] font-bold text-white text-left w-full" style={{color:"#fff"}}>
                                                <span>Application No.: {content?.ApplicationNo?.replace(/\u00A0/g, " ")}</span>
                                                <div className="flex flex-wrap gap-2 lg:border-l border-white lg:pl-2">
                                                    <div className="flex items-center gap-2">
                                                        <span className="lg:inline" style={{color:"#fff"}}>Status: </span>
                                                        <span className={`text-sm font-normal px-2 py-1 rounded-[2px] ${content?.Status === "Issued" ? "text-[#006139] bg-[#f2f7f5]" : "text-[#D76F1F] bg-[#FFF9EB]"}`}>
                                                            {content?.Status?.replace(/\u00A0/g, " ")}
                                                        </span>
                                                    </div>
                                                    {content.IssuedTo && (
                                                        <div className="flex items-center gap-2">
                                                            <span className="text-sm font-normal" style={{color:"#fff"}}>to</span>
                                                            <span className="text-sm font-normal px-2 py-1 rounded-[2px] bg-white/10" style={{color:"#fff"}}>
                                                                {content?.IssuedTo?.replace(/\u00A0/g, " ")}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {content?.IssueDate && (
                                                <div className="flex gap-2 text-[16px] lg:text-[20px] font-bold items-center text-white text-left mt-2 lg:mt-0" style={{ color: "#fff" }}>
                                                    <span>Issued On:</span>
                                                    <Image src={content?.IssuedIcon?.filename} alt={content?.IssuedIcon?.alt} className="w-[20px] h-[24px] lg:w-[24px] lg:h-[29px] object-cover" width={24} height={29} />
                                                    <span>{new Date(content?.IssueDate?.split(" ")[0]).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                                                </div>
                                            )}
                                        </div>
                                        <p className="text-[24px] lg:text-[28px] text-left px-4 lg:px-6 py-4 lg:py-6 font-bold font-lato bg-custom-radial bg-clip-text text-transparent">
                                            {content?.Title?.replace(/\u00A0/g, " ")}
                                        </p>
                                        <p className="text-[16px] lg:text-[18px] text-left px-4 lg:px-6 pb-4 lg:pb-6 font-normal">
                                            {content?.Description?.replace(/\u00A0/g, " ")}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
}

export default Patent;

